import { isCapabilityEnabled } from 'owa-capabilities';
import type { Capability } from 'owa-capabilities';
import type { MailboxInfo } from 'owa-client-types';
import { isGlobalFeatureEnabled } from 'owa-feature-flags';
import { newHeaderCapability } from './newHeaderCapability';

/**
 * NOTE: Please see the README for more information on how the
 * capability functions must be implemented and used.
 *
 * This capability is being used to gate add-ins pane resizing based on
 * new header availability and feature flag state.
 */
export const addinsResizablePaneCapability: Capability = {
    isEnabled: (_mailboxInfo?: MailboxInfo) => {
        return true;
    },
    isSupported: (_mailboxInfo?: MailboxInfo) => {
        return (
            isGlobalFeatureEnabled('addin-pane-resize') && isCapabilityEnabled(newHeaderCapability)
        );
    },
};
